import React, { useState } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import { connect } from 'react-redux';
import styles from './Styles/upload-prompt.scss';
import { bulkUpdateSteps } from './constants/bulkupdateinventory.constants';
import BulkUpdateInitialStep from './BulkUpdateInitialStep';
import BulkUpdateHistory from './bulkupdatehistory/BulkUpdateHistory';
import UploadProgress from './UploadProgress/UploadProgress';

const BulkUpdateInventory = props => {
  const [currentStep, setcurrentStep] = useState(() => ({ step: bulkUpdateSteps.initial }));
  const leftIcons = [
    {
      className: 'icon-HDRback',
      onClick: () => {
        if (currentStep.step !== bulkUpdateSteps.initial) {
          setcurrentStep(() => ({ step: bulkUpdateSteps.initial }))
        } else {
          props.onHidden();
          window.history.back();
        }
      }
    }
  ];
  const rightIcons = [
    {
      className: 'icon-glHistory icon-piHistory' + ' ' + styles['bigIcon'],
      onClick: () => {
        setcurrentStep(() => ({ step: bulkUpdateSteps.history }))
      }
    }
  ]

  return (
    <SliderWrapper
      header={{
        heading: 'Bulk Update Inventory',
        leftIcons,
        rightIcons,
      }}
    >
      {(() => {
        switch (currentStep.step) {
          case bulkUpdateSteps.initial:
            return <BulkUpdateInitialStep
              setCurrentStep={setcurrentStep}
              session={props.session}
            />;

          case bulkUpdateSteps.history:
            return <BulkUpdateHistory
              supplierId={props.session.supplierId}
              onHidden={props.onHidden}
              setCurrentStep={() => setcurrentStep(() => ({ step: bulkUpdateSteps.initial }))}
            />;

          case bulkUpdateSteps.uploadFile:
            return <UploadProgress
              session={props.session}
              step={currentStep}
              setStep={setcurrentStep}
              onClose={props.onHidden}
            />;

          default:
            return <BulkUpdateInitialStep
              setCurrentStep={setcurrentStep}
              session={session}
            />;
        }
      })()}
    </SliderWrapper>
  )
};

const mapStateToProps = state => {
  return {
    session: state.session,
    isMobile: state.library.deviceData.isMobile,
  }
}

export default connect(mapStateToProps)(BulkUpdateInventory);